import React, { useContext, useState } from "react";
import "./PortfolioPage.scss";
import Card from "./components/Card/Card";
import cat from "../../materials/cat.jpg";
import Button from "../Button";
import { useDataContext } from "../../contexts/Context";
import { DotLoader } from "react-spinners";
import PaginatedItems from "./components/PaginatedItems";

export default function PortfolioPage({ tilt }) {
  const { url, project, loading, data, cards, img } = useDataContext();
  const [cardNum, setCardNum] = useState(0);

  return (
    <div className="portfolio-page__container">
      <div data-aos="zoom-in" className="portfolio-page__background">
        <div className="portfolio-page__backround--1"></div>
        <div className="portfolio-page__backround--2"></div>
        <div className="portfolio-page__backround--3"></div>
        <div className="portfolio-page__backround--4"></div>
    
      </div>

     

      <div className="portfolio-page__projects" >
        <h3 className="portfolio-title">Projects</h3>

        <div>
          <div className="portfolio-page__projects__container">
            <div className="portfolio__project-list">
              <PaginatedItems />
            </div>

            <div className="portfolio__project-preview">
              <div className="project__container">
                <div className="project__img">
                  {loading ? (
                    <div className="project__loading">
                      <DotLoader color="white" />
                    </div>
                  ) : (
                    <img src={url} alt="" />
                  )}
                </div>
                <div className="project__info">
                  <h4>{project && project} project </h4>
                  <p>{data?.description}</p>
                </div>
                <div className="project__buttons" id="projects">
                  <Button
                    text={"View site"}
                    siteLink={!loading ? data?.siteLink : ""}
                    
                  />
                  <Button
                    text={"View code"}
                    codeLink={!loading ? data?.codeLink : ""}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
